module.exports = __webpack_public_path__ + "static/media/map-arrow.262f6502.png";